import { DOCUMENT } from '@angular/common'
import { inject, Injectable } from '@angular/core'
import { DeviceDetectorService, isTvUserAgent } from '@shared-services/device.detector.service'
import { getTvReturnUrl } from './tv-return-url'
export function resolveTvContext(url: string, userAgent: string, returnUrl?: unknown): 'ENTRY' | 'ISOLATED' | 'ORDINARY' {
  const [path, query = ''] = url.split('?')
  if (getTvReturnUrl(path) || getTvReturnUrl(returnUrl) || getTvReturnUrl(new URLSearchParams(query).get('returnUrl'))) return 'ORDINARY'
  if (!isTvUserAgent(userAgent)) return 'ORDINARY'
  if (path === '/tv' || path === '/tv/reproducir') return 'ISOLATED'
  return path === '' || path === '/' || path === '/iniciar-sesion' ? 'ENTRY' : 'ORDINARY'
}

@Injectable({ providedIn: 'root' })
export class TvEntryContext {
  private readonly detector = inject(DeviceDetectorService)
  private readonly document = inject(DOCUMENT)
  resolve(url: string, returnUrl?: unknown) {
    return resolveTvContext(url, this.detector.getUserAgent(), returnUrl)
  }
  isolatedBootstrap(): boolean {
    const { pathname, search } = this.document.location
    return this.resolve(`${pathname}${search}`) !== 'ORDINARY'
  }
}
